import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Express(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.19 4.94c4.824 0 8.749 3.924 8.749 8.748 0 4.822-3.925 8.748-8.748 8.748-4.824 0-8.748-3.925-8.748-8.748 0-4.824 3.924-8.749 8.748-8.749zm0 2a6.755 6.755 0 00-6.747 6.747 6.755 6.755 0 006.748 6.749 6.755 6.755 0 006.748-6.748 6.755 6.755 0 00-6.748-6.749zM6.043 18.175a1 1 0 110 2H4.666a1 1 0 110-2h1.376zm-1.26-2.855a1 1 0 110 2H2.425a1 1 0 110-2h2.357zM15.19 8.63a1 1 0 011 1l-.001 3.057h3.172a1 1 0 110 2h-4.058l-.056-.001a1 1 0 01-1.057-.998V9.628a1 1 0 011-1zM4.646 12.466a1 1 0 110 2H1a1 1 0 110-2h3.646zm.136-2.855a1 1 0 110 2H2.425a1 1 0 110-2h2.357zm1.26-2.854a1 1 0 110 2H4.666a1 1 0 110-2h1.376zM17.043 2a1 1 0 110 2h-3.706a1 1 0 110-2h3.706z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoExpress = React.memo(Express);
export default MemoExpress;